export const PUBLIC_ROUTES = ["/vendor/getstarted"];
